// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1g-2";
export var blackBorderOnHover = "_1g-7";
export var cell = "_1g-6";
export var cellContainer = "_1g-3";
export var checked = "_1g-8";
export var disabled = "_1g-5";
export var featuredIconCellContainer = "_1g-9";
export var featuredIconTextContainer = "_1g-b";
export var featuredIconWrapper = "_1g-a";
export var noBorder = "_1g-c";
export var orangeSelectedRow = "_4c-3";
export var overflowableText = "_1g-0";
export var overflowableTextContainer = "_1g-1";
export var row = "_1h-0";
export var rowCheckboxCell = "_1g-4";
export var selectableTable = "_4c-2";